/* eslint-disable camelcase */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../store/reducers';
import { dismissToast } from '../../../store/actions/toast';
import PriceDisplay from '../../PriceDisplay';
import getRoute from '../../../../scripts/utils/getRoute';

interface CartToastBodyProp {
  productIds: any;
  cartTitleText: string;
  cartButtonText: string;
}

const CartToastBody = (props: CartToastBodyProp): JSX.Element => {
  const dispatch = useDispatch();
  const cartItems = useSelector((state: RootState) => state.cart.current.items);
  const {
    cartTitleText,
    productIds,
    cartButtonText
  } = props;

  const title = cartTitleText.replace('{{ item_count }}', productIds.length);
  const products = cartItems.filter((cartItem) => productIds.indexOf(cartItem.id) > -1);
  return (
    <>
      <header className="toast__header">
        <i></i>
        <p className="toast__title">{title}</p>
        <button aria-label="close" className="btn-close" onClick={() => dispatch(dismissToast())}></button>
      </header>
      <div className="toast__body">
        <ul className="list-products">
          {
            products.map((product, i) => (
              <li className="product" key={'cart-product-' + i}>
                <img loading="lazy" className="product-image" src={product.image} alt={product.title} />
                <div className="product-detail">
                  <p className="title">{product.title}</p>
                  <PriceDisplay product={{
                    price: product.price,
                    final_price: product.final_price,
                    total_discount: product.total_discount
                  }} />
                </div>
              </li>
            ))
          }
        </ul>
        <a href={`${getRoute()}cart`} className="btn btn--tertiary btn--cart">{cartButtonText}</a>
      </div>
    </>
  );
};

export default CartToastBody